import { Outlet, useNavigate } from "react-router-dom";
import { useAuthStore } from "../auth.store";
import { useEffect } from "react";

interface AuthLayoutProps {
  children?: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  const { customer, accessToken } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (customer && accessToken) {
      navigate("/", { replace: true });
    }
  }, [customer, accessToken, navigate]);

  return (
    <div className="flex items-center justify-center p-5 ">
      {children ? children : <Outlet />}
    </div>
  );
}
